import React from "react";

import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

import chatEmptySvg from "../../../../assets/images/messages-empty.svg";
import Padding from "../../../../components/layout/Padding";

const useStyles = makeStyles()({
  root: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontWeight: 700,
    fontSize: 28,
    lineHeight: "18px",
    color: colors.dark,
  },
  subtitle: {
    fontWeight: 600,
    fontSize: 16,
    lineHeight: 1,
    color: colors.gray,
  },
});

const ChatEmptyView: React.FC = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.root}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        margin="52px"
      >
        <img src={chatEmptySvg} />
        <Box marginBottom={5} />
        <Typography className={classes.title}>Say Hello!</Typography>
        <Box marginBottom={5} />
        <Typography className={classes.subtitle}>
          You haven&apos;t started a conversation yet.
        </Typography>
      </Box>
    </div>
  );
};

export default ChatEmptyView;
